/* Hulk Discounts × Add to Cart integration for Empire
   - Forces “Buy 1” as default tier
   - Makes theme “Add to Cart” trigger Hulk’s “Grab This Deal” logic
*/
(function () {
  if (window.__hulkAtcIntegrated) return;
  window.__hulkAtcIntegrated = true;

  // --- utilities ---
  const onReady = (fn) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else { fn(); }
  };

  const waitFor = (testFn, { tries = 40, interval = 125 } = {}) =>
    new Promise((res, rej) => {
      let n = 0;
      const id = setInterval(() => {
        if (testFn()) { clearInterval(id); res(true); }
        else if (++n >= tries) { clearInterval(id); rej(new Error('timeout')); }
      }, interval);
    });

  // --- 1) Force “Buy 1” default selection ---
  function selectBuyOne(widget) {
    const radios = Array.from(widget.querySelectorAll('input[type="radio"]'));
    if (!radios.length) return;

    let target =
      radios.find(r => r.dataset.minQty === '1') ||
      radios.find(r => (r.value || '').trim() === '1') ||
      radios.find(r => /Buy\s*1\b/i.test(r.closest('label')?.textContent || ''));

    if (!target) {
      const withQty = radios.map(r => {
        const txt = r.closest('label')?.textContent || '';
        const m = txt.match(/\b(\d+)\b/);
        return { r, q: m ? parseInt(m[1], 10) : Infinity };
      });
      withQty.sort((a, b) => a.q - b.q);
      target = (withQty[0] && isFinite(withQty[0].q)) ? withQty[0].r : radios[0];
    }

    if (!target.checked) {
      target.checked = true;
      target.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  async function enforceBuyOne() {
    const widget = document.querySelector('.hulkapps-volumes');
    if (!widget) return;

    try {
      await waitFor(() => widget.querySelectorAll('input[type="radio"]').length > 0);
      [0, 150, 400, 900].forEach(d => setTimeout(() => selectBuyOne(widget), d));

      const mo = new MutationObserver(() => selectBuyOne(widget));
      mo.observe(widget, { childList: true, subtree: true });
    } catch (_) { /* noop */ }
  }

  // --- 2) Make “Add to Cart” behave like “Grab This Deal” ---
  function wireAddToCartProxy() {
    document.addEventListener('click', function (e) {
      const atc = e.target.closest('button[name="add"], [data-add-to-cart]');
      if (!atc) return;

      const widget = document.querySelector('.hulkapps-volumes');
      if (!widget) return;

      const selectedTier = widget.querySelector('input[type="radio"]:checked');
      if (!selectedTier) return;

      e.preventDefault();

      const dealBtn =
        widget.querySelector('[data-action="grab-deal"]') ||
        widget.querySelector('.grab-deal-btn') ||
        widget.querySelector('[id*="grab-deal"]');

      if (dealBtn) {
        dealBtn.click();
        return;
      }

      const container = selectedTier.closest('[data-min-qty]') || selectedTier.closest('label');
      const minQty =
        parseInt(container?.dataset?.minQty, 10) ||
        parseInt((container?.textContent || '').match(/\b(\d+)\b/)?.[1] || '1', 10);

      const qtyInput = document.querySelector('form[action*="/cart/add"] input[name="quantity"]');
      if (qtyInput) qtyInput.value = Math.max(minQty, parseInt(qtyInput.value || '1', 10));

      if (atc.form) {
        atc.form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      } else {
        atc.click();
      }
    });
  }

  // --- init ---
  onReady(() => {
    const root = document.querySelector('#MainContent') || document.body;
    enforceBuyOne();
    const mo = new MutationObserver(() => enforceBuyOne());
    mo.observe(root, { childList: true, subtree: true });
    wireAddToCartProxy();
  });
})();
